export enum DeprecatedJobId {
    SwimmingPoolAndSpaSpecialist = 'swimmingPoolAndSpaSpecialist',
}

export enum PublishedJobId {
    CabinetmakerCarpenter = 'cabinetmakerCarpenter',
    Designer = 'designer',
    GlazierMirrorMaker = 'glazierMirrorMaker',
    IronworkerMetalWorkerZincWorker = 'ironworkerMetalWorkerZincWorker',
    KitchenDesigner = 'kitchenDesigner',
    MarbrierStoneCutter = 'marbrierStoneCutter',
    SpecialistDeckPatioAndVeranda = 'specialistDeckPatioAndVeranda',
    WindowdoorShutterAndBlindSpecialist = 'windowdoorShutterAndBlindSpecialist',
    ParquetFloorWorker = 'parquetFloorWorker',
    LandscaperGardener = 'landscaperGardener',

    Facade = 'facade',
    FloorTilerAndInstaller = 'floorTilerAndInstaller',
    Locksmith = 'locksmith',
    ProfessionalSecondWork = 'professionalSecondWork',
    RooferCarpenter = 'rooferCarpenter',
    SellerAndInstallerOfFenceAndGate = 'sellerAndInstallerOfFenceAndGate',
    UpholstererUpholsteryAndCarpet = 'upholstererUpholsteryAndCarpet',
    WineCellarDesigner = 'wineCellarDesigner',
}

export type JobId = DeprecatedJobId | PublishedJobId;

export default PublishedJobId;
